import React, { useState, useRef, useEffect } from 'react';
import { MessageCircle, X, Send } from 'lucide-react';

export default function Chatbot() {
  const [isOpen, setIsOpen] = useState(false);
  const [messages, setMessages] = useState([
    { id: 1, text: "Hi! I'm Lokesh's AI assistant. How can I help you today?", sender: 'bot' }
  ]);
  const [inputText, setInputText] = useState('');
  const [isTyping, setIsTyping] = useState(false);
  const messagesEndRef = useRef(null);

  const botResponses = {
    'hello': "Hello! Nice to meet you! How can I assist you today?",
    'hi': "Hi there! What would you like to know about Lokesh?",
    'projects': "Lokesh has worked on various projects including e-commerce platforms, weather apps, and chat applications. You can check them out in the Projects section!",
    'skills': "Lokesh specializes in Java, React, Spring Boot, MySQL, MongoDB, and more. Check the About section for the complete tech stack!",
    'experience': "Lokesh has experience as a Web Developer Intern at Internpe and AI/Green Technology Intern at Shell (Edunet). View the Resume section for details!",
    'contact': "You can reach Lokesh at lokeshyuvaraj33@gmail.com or +91 87545 72686. Connect on LinkedIn or GitHub!",
    'default': "I'm here to help! You can ask me about Lokesh's projects, skills, experience, or contact information."
  };

  const scrollToBottom = () => {
    messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  useEffect(() => {
    scrollToBottom();
  }, [messages]);

  const handleSend = async () => {
    if (!inputText.trim()) return;

    const userMessage = { id: Date.now(), text: inputText, sender: 'user' };
    setMessages(prev => [...prev, userMessage]);
    setInputText('');
    setIsTyping(true);

    // Simulate API delay
    setTimeout(() => {
      const response = getBotResponse(inputText.toLowerCase());
      const botMessage = { id: Date.now() + 1, text: response, sender: 'bot' };
      setMessages(prev => [...prev, botMessage]);
      setIsTyping(false);
    }, 1000);
  };

  const getBotResponse = (input) => {
    // Simple keyword matching
    for (const [keyword, response] of Object.entries(botResponses)) {
      if (keyword !== 'default' && input.includes(keyword)) {
        return response;
      }
    }
    return botResponses['default'];
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      handleSend();
    }
  };

  return (
    <>
      {/* Chat Toggle Button */}
      <div 
        className={`chat-toggle ${isOpen ? 'open' : ''}`}
        onClick={() => setIsOpen(!isOpen)}
      >

        {isOpen ? <X size={20} /> : <MessageCircle size={24} />}
      </div>

      {/* Chat Window */}
      {isOpen && (
        <div className="chat-window">
          <div className="chat-header">
            <h3>Chat with AI Assistant</h3>
            <button onClick={() => setIsOpen(false)}>
              <X size={20} />
            </button>
          </div>
          
          <div className="chat-messages">
            {messages.map((message) => (
              <div key={message.id} className={`message ${message.sender}`}>
                <div className="message-content">
                  {message.text}
                </div>
              </div>
            ))}
            
            {isTyping && (
              <div className="message bot">
                <div className="message-content typing">
                  <div className="typing-dots">
                    <span></span>
                    <span></span>
                    <span></span>
                  </div>
                </div>
              </div>
            )}
            <div ref={messagesEndRef} />
          </div>

          <div className="chat-input">
            <input
              type="text"
              value={inputText}
              onChange={(e) => setInputText(e.target.value)}
              onKeyPress={handleKeyPress}
              placeholder="Type your message..."
            />
            <button onClick={handleSend}>
              <Send size={20} />
            </button>
          </div>
        </div>
      )}
    </>
  );
}